// extracted by mini-css-extract-plugin
module.exports = {"rating":"rating-15bke","star":"star-12vqX","highlighted":"highlighted-HdIaJ"};